// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Waypoint from 'react-waypoint'

// Internal Dependencies:
import { get } from 'utilities/objects'
import LoadingSpinner from 'components/LoadingSpinner/LoadingSpinner'
import EventsCalendar from 'components/EventsCalendar/EventsCalendar'

// Redux:
import { getEventsData, getPageData } from 'actions/page'

class EventsLayout extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		dispatch( getEventsData() )
	}

	renderLegend = () => {
		const { loadingEvents, eventsCategoriesById } = this.props

		if ( loadingEvents || ! eventsCategoriesById ) {
			return null
		}

		const markup = Object.keys( eventsCategoriesById ).map( key => {
			let item = eventsCategoriesById[ key ]
			let colorStyle = {
				backgroundColor: item.color
			}

			return (
				<div className="-item" key={ key }>
					<div className="-colour" style={ colorStyle }></div>
					<div className="-text">{ item.name }</div>
				</div>
			)
		} )

		return (
			<div className="events-legend">
				{ markup }
			</div>
		)
	}

	render() {
		const { loadingEvents, eventsById } = this.props

		return (
			<div>
				<div className="main-inner">
					{ loadingEvents &&
						<LoadingSpinner />
					}

					<div className="wide-sections">
						<div className="category-heading">
							<div className="-inner">
								<h2>Events</h2>

								{ this.renderLegend() }
							</div>
						</div>

						<EventsCalendar eventsById={ eventsById } />
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		// loadingEvents: state.page.loadingEvents,
		loadingEvents: false,
		eventsById: state.page.eventsById,
		eventsCategoriesById: state.page.eventsCategoriesById
	}
}

export default connect( mapStateToProps )( EventsLayout )
